import CoreComponent from '../../core/CoreComponent.vue';
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
export default {
  extends: CoreComponent,
  data: () => {
    return {
      isMobile: null,
      micrositeNavTrigger: null,
      openIcon: null,
      closeIcon: null,
      swiperInstance: null
    };
  },
  mounted() {
    // Add microsite header class if XF contains header in microsite variant
    const headerXF = document.querySelector('.experiencefragment.main-header');
    if (headerXF && headerXF.querySelector('.microsite-light')) {
      headerXF.classList.add('microsite-header-XF');
    }

    // Hide the mobile header container initially
    this.rearrangeHeaderElements();
    window.addEventListener('resize', this.rearrangeHeaderElements);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.rearrangeHeaderElements);
    this.destroySwiper();
  },
  methods: {
    initSwiper() {
      this.destroySwiper();
      const container = this.cmpEl.querySelector('.main-header-slider');
      if (!container) return;
      this.swiperInstance = new Swiper(container, {
        slidesPerView: 'auto',
        freeMode: true,
        modules: [Navigation, FreeMode],
        navigation: {
          nextEl: this.cmpEl.querySelector('.swiper-button-next'),
          prevEl: this.cmpEl.querySelector('.swiper-button-prev')
        }
      });
    },
    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    },
    rearrangeHeaderElements() {
      // Scope queries to this.cmpEl to avoid collisions with other swiper instances.
      const swiperWrapper = this.cmpEl.querySelector('.swiper-wrapper');
      const mobileHeaderContainer = this.cmpEl.querySelector('.mobile-header-container');
      const desktopHeaderContainer = this.cmpEl.querySelector('.main-header-slider');
      const headerContainer = document.querySelector('.cmp--header_container');
      const header = this.cmpEl;
      const languageSelector = document.querySelector('.cmp--header_language-modal-wrapper');
      this.micrositeNavTrigger = this.cmpEl.querySelector('.microsite-nav-trigger');
      if (this.micrositeNavTrigger) {
        this.openIcon = this.micrositeNavTrigger.querySelector(".container-hamburger-open");
        this.closeIcon = this.micrositeNavTrigger.querySelector(".container-hamburger-close");
        this.micrositeNavTrigger.addEventListener('click', this.onMicrositeNavTriggerClick);
      }
      const wrapper = this.cmpEl.querySelector('.dropdown-toggle-wrapper');
      const dropdowns = this.cmpEl.querySelectorAll('.dropdown-box');
      if (!swiperWrapper || !mobileHeaderContainer || !desktopHeaderContainer || !header) return;
      this.destroySwiper();
      if (window.innerWidth <= 768) {
        this.isMobile = true;
        mobileHeaderContainer.appendChild(swiperWrapper);
        header.classList.add('mobile');
        desktopHeaderContainer.style.display = 'none';
        swiperWrapper.style.transform = 'none';
        const offset = (headerContainer ? headerContainer.getBoundingClientRect().height : 0) + header.getBoundingClientRect().height;
        mobileHeaderContainer.style.top = offset + 'px';
        if (languageSelector) languageSelector.style.top = offset + 'px';
        dropdowns.forEach(box => {
          box.style.top = 0 + 'px';
        });
      } else {
        this.isMobile = false;
        desktopHeaderContainer.appendChild(swiperWrapper);
        header.classList.remove('mobile');
        desktopHeaderContainer.style.display = 'block';
        mobileHeaderContainer.style.display = 'none';
        const headerRect = header.getBoundingClientRect();
        if (wrapper && languageSelector) {
          const wrapperRect = wrapper.getBoundingClientRect();
          const offset = wrapperRect.height + (headerRect.height - wrapperRect.height) / 2;
          languageSelector.style.top = headerRect.bottom + 'px';
          dropdowns.forEach(box => {
            box.style.top = offset + 'px';
          });
        }
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
      this.closeMicrositeNav();
    },
    onMicrositeNavTriggerClick() {
      if (!this.isMobile) return;
      let mobileHeaderContainer = this.cmpEl.querySelector('.mobile-header-container');
      if (mobileHeaderContainer.style.display === 'none' || mobileHeaderContainer.style.display === '') {
        mobileHeaderContainer.style.display = 'block';
      } else {
        mobileHeaderContainer.style.display = 'none';
      }
      if (this.openIcon.style.display === 'none') {
        this.openIcon.style.display = 'block';
        this.closeIcon.style.display = 'none';
      } else {
        this.openIcon.style.display = 'none';
        this.closeIcon.style.display = 'block';
      }
    },
    closeMicrositeNav() {
      if (!this.isMobile) return;
      let mobileHeaderContainer = this.cmpEl.querySelector('.mobile-header-container');
      mobileHeaderContainer.style.display = 'none';
      this.openIcon.style.display = 'block';
      this.closeIcon.style.display = 'none';
    }
  }
};